import { useEffect } from "react";
import { useDispatch } from "react-redux";

import useCurrentUser from "../../../hooks/useCurrentUser";
import { ParticipantType } from "../../../types/resource.types";
import { UserRole } from "../../../types/user.types";
import { chatNotificationAction } from "../redux/actions";
import chatQueries from "./chatQueries";
import { canSeeChat } from "./index";

/**
 * use this hook to init chat, it has things like trigger app notifications
 * */
const useInitChat = () => {
  const dispatch = useDispatch();
  const { user } = useCurrentUser();

  useEffect(() => {
    if (user.id && canSeeChat(user.role)) {
      dispatch(
        chatNotificationAction({
          getOneUnseenRoomQuery: () =>
            chatQueries.getReceivedOneUnseenRoom({
              userId: user.id as string,
              type:
                user.role === UserRole.admin
                  ? ParticipantType.admin
                  : user.role === UserRole.sportClub
                  ? ParticipantType.sportsClubs
                  : user.role === UserRole.store
                  ? ParticipantType.brands
                  : user.role === UserRole.academy
                  ? ParticipantType.academies
                  : user.role === UserRole.coach
                  ? ParticipantType.coaches
                  : user.role === UserRole.gym
                  ? ParticipantType.gyms
                  : ParticipantType.entertainments,
            }),
        })
      );
    }
  }, [user.id]);
};

export default useInitChat;
